import type { HpChangeKind } from "@dm/shared";
import { api } from "./api.js";
import { useGame } from "./game.js";
import { Avatar } from "./Avatar.js";
import { DeathSaves, HpBar, HpControls } from "./Hp.js";

export function PartyPanel() {
  const { party, isHost, user, campaign, fail } = useGame();
  return (
    <section className="panel">
      <h3>Party</h3>
      {party.length === 0 && (
        <p className="muted">
          No characters yet. <a href="#/wizard">🧙 Create with wizard</a> or <a href="#/character">fill in a sheet</a>.
        </p>
      )}
      <ul className="party">
        {party.map((c) => {
          const canEdit = isHost || c.ownerDiscordId === user.discordId;
          const hp = async (kind: HpChangeKind, amount: number) => {
            await api.characterHp(campaign.id, c.id, kind, amount).catch(fail);
          };
          return (
            <li key={c.id} className={c.currentHp <= 0 ? "is-down" : ""}>
              <Avatar c={c} size={36} />
              <div className="who">
                <strong>{c.name}</strong>
                <span className="muted small">
                  {[c.race, c.className].filter(Boolean).join(" ")} {c.level} · {c.ownerName}
                </span>
                {(c.details.conditions.length > 0 || c.details.exhaustion > 0) && (
                  <span className="cond-tags">
                    {c.details.conditions.map((k) => (
                      <span key={k} className="tag cond-tag">
                        {k}
                      </span>
                    ))}
                    {c.details.exhaustion > 0 && <span className="tag cond-tag">exhaustion {c.details.exhaustion}</span>}
                  </span>
                )}
                {c.currentHp <= 0 && (
                  <>
                    <span className="tag down">down</span>
                    <DeathSaves {...c.deathSaves} />
                  </>
                )}
              </div>
              <HpBar hp={c.currentHp} maxHp={c.maxHp} tempHp={c.tempHp} />
              <span className="ac">AC {c.ac}</span>
              {canEdit ? <HpControls onChange={hp} /> : <span />}
              {canEdit ? (
                <a className="small" href={`#/character/${c.id}`}>
                  {c.ownerDiscordId === user.discordId ? "Sheet" : "Edit"}
                </a>
              ) : (
                <a className="small" href={`#/character/${c.id}`}>
                  View
                </a>
              )}
            </li>
          );
        })}
      </ul>
    </section>
  );
}
